import { render, staticRenderFns } from "./Sunset.vue?vue&type=template&id=1540fef5&"
import script from "./Sunset.vue?vue&type=script&lang=js&"
export * from "./Sunset.vue?vue&type=script&lang=js&"
import style0 from "./Sunset.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Sunset.vue"
export default component.exports